<template>
    <div class="data">
        <input-media :label="$t('Movie')" v-model="video.video" @change="video.patch('video')" :storie-id="video.getStoryId()" required/>
        <input-select :label="$t('Orientation')" :items="[{text:$t('Horizontal'), value:'horizontal'},{text:$t('Vertical'), value:'vertical'}]" v-model="video.orientation" @change="video.patch('orientation')"/>
        <input-select :label="$t('Fit')" :items="[{text:$t('Cover'), value:'cover'},{text:$t('Contain'), value:'contain'}]" v-model="video.fit" @change="video.patch('fit')"/>
        <input-select :label="$t('Subtype')" :items="[{text:$t('Standard'), value:'standard'},{text:$t('Video 360'), value:'video_360'}]" v-model="video.subtype" @change="video.patch('subtype')"/>
        <div class="row">
            <div class="col-4"><input-checkbox :label="$t('Muted')" v-model="video.muted"  @change="video.patch('muted')"/></div>
            <div class="col-4"><input-checkbox :label="$t('Autostart')" v-model="video.autostart" @change="video.patch('autostart')" /></div>
            <div class="col-4"><input-checkbox :label="$t('Show Controls')" v-model="video.show_controls" @change="video.patch('show_controls')" /></div>
        </div>
    </div>
</template>

<script>
import InputMedia from "@/modules/input/input-media";
import {video} from "@/class/video/video";
import InputText from "@/modules/input/input-text";
import InputSelect from "@/modules/input/input-select";
import InputCheckbox from "@/modules/input/input-checkbox";
export default {
    name: "Video_Data",
    components: {InputCheckbox, InputSelect, InputText, InputMedia},
    props:{
        video:{type:Object, default:new video()}
    }
}
</script>